import axios from "axios";
import { gateway as apiUrl } from "../../api";

export function addInterInvoice(data) {
  return axios.post(`${apiUrl}/invoice`, data);
}

export function addInterInvoiceCancellation(data) {
  return axios.post(`${apiUrl}/cancel`, data);
}

export function addInvoiceRequest(data) {
  return axios.post(`${apiUrl}/invoice/request`, data);
}

export function loadInvoicePayment(id) {
  return axios.get(`${apiUrl}/invoice/payment?logs__invoice_id=${id}`);
}

export function loadInvoicePaymentDetails(id) {
  return axios.get(`${apiUrl}/invoice/payment/details/${id}`);
}

export function loadInvoiceLogsDetails(id) {
  return axios.get(`${apiUrl}/invoice/logs/details/${id}`);
}

export function loadInvoiceReconciliation(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/reconciliation/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`,
  );
}

export function addReconciliationRequest(data) {
  return axios.post(`${apiUrl}/reconciliation/request`, data);
}

export function loadERMSData(
  pageLimit,
  page,
  date,
  status,
  datatype,
  controlNumber,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/erms-data?limit=${pageLimit}&offset=${page}&recorded_at__range=${date}&status__in=${status}&datatype__in=${datatype}&request_controlNumber=${controlNumber}&search=${search}&ordering=${order}`,
  );
}

export function loadSingleERMSData(id) {
  return axios.get(`${apiUrl}/erms-data?id__in=${id}`);
}

//=============================== --- IGNORE --- ===============================

export function loadCustomerInvoice(id) {
  return axios.get(`${apiUrl}/customer-invoice/${id}`);
}

export function loadCustomerPayment(id) {
  return axios.get(`${apiUrl}/customer-payment/${id}`);
}

export function loadCustomerClearance(id) {
  return axios.get(`${apiUrl}/customer-clearance/${id}`);
}

export function loadCustomerDiscount(id) {
  return axios.get(`${apiUrl}/customer-discount/${id}`);
}

export function loadCustomerTransaction(id) {
  return axios.get(`${apiUrl}/customer-transaction/${id}`);
}

//=============================== --- IGNORE --- ==================================
export function addInvoiceClearance(data) {
  return axios.post(`${apiUrl}/invoice-clearance`, data);
}

export function approveInvoiceClearance(id, data) {
  return axios.post(`${apiUrl}/invoice-clearance/approve/${id}`, data);
}

export function rejectInvoiceClearance(id, data) {
  return axios.post(`${apiUrl}/invoice-clearance/reject/${id}`, data);
}

export function loadInvoiceClearance(pageLimit, page, search, order) {
  const params = new URLSearchParams({
    limit: pageLimit,
    offset: page,
    search: search,
    ordering: order,
  });
  return axios.get(`${apiUrl}/invoice-clearance/list?${params.toString()}`);
}

export function loadUnApprovedClearance() {
  return axios.get(`${apiUrl}/clearance/approval`);
}

export function loadInvoiceClearanceById(id) {
  return axios.get(`${apiUrl}/invoice-clearance/data/${id}`);
}

export function addInvoiceDiscount(data) {
  return axios.post(`${apiUrl}/invoice-discount`, data);
}

export function approveInvoiceDiscount(id, data) {
  return axios.post(`${apiUrl}/invoice-discount/approve/${id}`, data);
}

export function rejectInvoiceDiscount(id, data) {
  return axios.post(`${apiUrl}/invoice-discount/reject/${id}`, data);
}

export function loadInvoiceDiscount(pageLimit, page, search, order) {
  const params = new URLSearchParams({
    limit: pageLimit,
    offset: page,
    search: search,
    ordering: order,
  });
  return axios.get(`${apiUrl}/invoice-discount/list?${params.toString()}`);
}

export function loadInvoiceDiscountById(id) {
  return axios.get(`${apiUrl}/invoice-discount/data/${id}`);
}

//===========================================================================
export function addStudentProfile(data) {
  return axios.post(`${apiUrl}/student-profile`, data);
}
